<template>
  <div class="labelStyle">
    <div
      v-for="subitem in attrs.value"
      :key="subitem"
      class="labelItem"
      :class="variant_attrs[index].value == subitem ? 'active' : ''"
    >
      <input
        v-model="variant_attrs[index].value"
        :id="key_name + variant_attrs[index].name + index + subitem"
        :value="subitem"
        :name="key_name + variant_attrs[index].name"
        type="radio"
      />
      <label
        class="secondary_title"
        :for="key_name + variant_attrs[index].name + index + subitem"
      >
        {{ subitem }}
      </label>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    variant_attrs: {},
    index: {},
    attrs: {},
    theme: {},
    key_name: {},
    lable_active: {},
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
.labelStyle {
  .labelItem {
    display: inline-block;
    label {
      margin: 0;
      cursor: pointer;
      font-weight: 600;
      font-style: normal;
      letter-spacing: 0.1em;
      line-height: 1;
      padding: 9px 11px;
      margin: 3px 10px 7px 0px;
      font-size: 0.86667em;
      font-style: normal;
      background-color: #fff;
      border: 1px solid #d2d2d2;
      color: #222323;
      cursor: pointer;
    }
    input {
      clip: rect(0, 0, 0, 0);
      overflow: hidden;
      position: absolute;
      height: 1px;
      width: 1px;
      // &:focus + label,
      // &:active + label {
      //   background-color: #f2f2f2;
      // }
    }
  }
  .active {
    label {
      background-color: var(--main-btn-bg);
      border-color: var(--main-btn-bg);
      color: var(--main-btn-tx);
    }
  }
}
</style>